app.service('menuBar', function(menu, searchBox) {
	function setEvents() {
		$('#hamburger')
			.on('click', menu.open)
			.on('keydown', function(e) {
				if (e.key === 'Enter' || e.key === ' ') { // Enter key or Space key
					e.preventDefault();
					e.stopPropagation();
					menu.open();
				}
			});
		$('#product-menu').on('click', menu.open);
		$('#search-menu').on('click keyup', function(e) {
			if (e.type === 'click' || e.type === 'keyup' && (e.key === 'Enter' || e.key === ' ')) {
				searchBox.open();
			}
		})
	}

	function init() {
		setEvents();
	}

	return {
		init
	};
});
